import { Theme } from '@mui/material';

const List = (theme: Theme) => {
  return {
    MuiListItem: {
      styleOverrides: {
        root: {
          '&:last-of-type': {
            borderBottom: 'none',
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          paddingRight: theme.spacing(2),
        },
      },
    },
  };
};

export default List;
